import { useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';

export const useFormatCurrency = () => {
    const formatter = useFormatter();

    return useCallback((data, options = {}) => formatter.formatCurrency(data.amount, {
        currencyCode: data.currencyCode,
        ...options
    }), [formatter]);
};
